import _ from "lodash";

import { actionTypes } from "app/store/modules/actions/file-rename-jobs.actions";

const initialState = {
  list: {
    data: [],
    count: 0,
  },
  page: 0,
  filter: {
    search: "",
    fromDate: null,
    toDate: null,
    order: "asc",
    orderBy: "index",
    archived: false,
    statusFilters: [],
    pageSize: 10,
  },
  selectedFileRenameJob: null,
  selection: {
    fileRenameJobs: {},
    selectedCountFromCurrentList: 0,
  },
};

const getSelectedFileRenameJobCount = (fileRenameJobs, selectionState) => {
  const selectedCount = fileRenameJobs.reduce((p, job) => {
    return p + (selectionState[job._id] ? 1 : 0);
  }, 0);

  return selectedCount;
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FILE_RENAME_JOBS_LOADED: {
      const { list } = action.payload;
      const selectedJobCount = getSelectedFileRenameJobCount(
        list.data,
        state.selection.fileRenameJobs
      );

      return {
        ...state,
        list,
        selection: {
          ...state.selection,
          selectedCountFromCurrentList: selectedJobCount,
        },
      };
    }

    case actionTypes.CHANGE_PAGE: {
      return {
        ...state,
        page: action.payload.page,
      };
    }

    case actionTypes.UPDATE_FILTER: {
      return {
        ...state,
        page: 0,
        filter: {
          ...state.filter,
          ...action.payload.data,
        },
      };
    }

    case actionTypes.SELECT_FILE_RENAME_JOB: {
      const selectedFileRenameJobs = _.clone(state.selection.fileRenameJobs);
      const { fileRenameJob } = action.payload;
      const jobId = fileRenameJob._id;

      selectedFileRenameJobs[jobId] = fileRenameJob;

      const selectedJobCount = getSelectedFileRenameJobCount(
        state.list.data,
        selectedFileRenameJobs
      );

      return {
        ...state,
        selection: {
          ...state.selection,
          fileRenameJobs: selectedFileRenameJobs,
          selectedCountFromCurrentList: selectedJobCount,
        },
      };
    }

    case actionTypes.UNSELECT_FILE_RENAME_JOB: {
      const selectedFileRenameJobs = _.clone(state.selection.fileRenameJobs);
      const { fileRenameJob } = action.payload;
      const jobId = fileRenameJob._id;

      delete selectedFileRenameJobs[jobId];

      const selectedJobCount = getSelectedFileRenameJobCount(
        state.list.data,
        selectedFileRenameJobs
      );

      return {
        ...state,
        selection: {
          ...state.selection,
          fileRenameJobs: selectedFileRenameJobs,
          selectedCountFromCurrentList: selectedJobCount,
        },
      };
    }

    case actionTypes.FILE_RENAME_JOB_CREATED: {
      const { fileRenameJob } = action.payload;

      return {
        ...state,
        list: {
          data: [...state.list.data, fileRenameJob],
          count: state.list.count + 1,
        },
      };
    }

    case actionTypes.FILE_RENAME_JOB_LOADED: {
      return {
        ...state,
        selectedFileRenameJob: action.payload.fileRenameJob,
        selection: {
          ...state.selection,
          fileRenameJobs: {},
          selectedCountFromCurrentList: 0,
        },
      };
    }

    case actionTypes.FILE_RENAME_JOB_UPDATED: {
      const { fileRenameJob } = action.payload;
      return {
        ...state,
        list: {
          data: state.list.data.map((job) =>
            job._id === fileRenameJob._id ? { ...job, ...fileRenameJob } : job
          ),
        },
        selectedFileRenameJob: { ...state.selectedFileRenameJob, ...fileRenameJob },
      };
    }

    case actionTypes.FILE_RENAME_JOB_SECTION_UPDATED: {
      const { section } = action.payload;

      const selectedFileRenameJob = _.cloneDeep(state.selectedFileRenameJob);
      selectedFileRenameJob.sections = selectedFileRenameJob.sections.map((s) =>
        section._id === s._id ? { ...s, ...section } : s
      );

      return {
        ...state,
        selectedFileRenameJob: selectedFileRenameJob,
        list: {
          data: state.list.data.map((job) =>
            job._id === selectedFileRenameJob._id ? selectedFileRenameJob : job
          ),
        },
      };
    }

    case actionTypes.FILE_RENAME_JOBS_ARCHIVED:
    case actionTypes.FILE_RENAME_JOBS_UNARCHIVED:
    case actionTypes.FILE_RENAME_JOBS_DELETED: {
      const { list } = state;
      const { requestIds } = action.payload;
      const updatedList = list.data.filter((job) => !requestIds.includes(job._id));

      return {
        ...state,
        list: {
          data: updatedList,
          count: list.count - requestIds.length,
        },
      };
    }

    case actionTypes.FILE_RENAME_JOBS_FILE_STATUS_UPDATED: {
      const { sectionId, fileId, fileObject } = action.payload;

      const selectedFileRenameJob = _.cloneDeep(state.selectedFileRenameJob);

      for (const section of selectedFileRenameJob.sections) {
        if (section._id === sectionId) {
          for (let index = 0; index < section.files.length; index++) {
            const file = section.files[index];

            if (file._id === fileId) {
              section.files[index] = { ...file, ...fileObject };
              break;
            }
          }
        }
      }

      return {
        ...state,
        selectedFileRenameJob: selectedFileRenameJob,
        list: {
          data: state.list.data.map((job) =>
            job._id === selectedFileRenameJob._id ? selectedFileRenameJob : job
          ),
        },
      };
    }

    case actionTypes.FILE_RENAME_JOB_CLEARED: {
      return {
        ...state,
        selectedFileRenameJob: null,
      };
    }

    default:
      return state;
  }
};
